import {
  HttpClient,
  provideHttpClient,
  withInterceptors
} from '@angular/common/http';
import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideZoneChangeDetection
} from '@angular/core';
import { provideRouter } from '@angular/router';

import {
  provideIconLoader,
  provideTheme
} from '@gruposaltaedu/liv-design-system/core';
import { provideHttpConnect } from '@gruposaltaedu/liv-http-connect';
import { provideI18n } from '@gruposaltaedu/liv-i18n/core';
import { provideOAuthClient } from 'angular-oauth2-oidc';

import { environment } from '@env/environment';

import { routes } from './app.routes';
import { StorageKeys } from './core/enums/storage-keys.enum';
import { GlobalErrorHandlerService } from './core/errors/global-error-handler.service';
import { httpInterceptorProviders } from './core/interceptors';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideI18n({
      supportedLanguages: ['es-MX', 'pt-BR'],
      defaultLanguage: 'pt-BR',
      storageKey: StorageKeys.Language,
      commonAssetsPrefix: './assets/i18n/',
      commonNamespace: 'common'
    }),
    provideHttpClient(withInterceptors([...httpInterceptorProviders()])),
    provideHttpConnect({
      baseUrl: environment.apiUrl,
      responseWrapper: {
        dataExtractKey: 'data',
        excludeUrls: ['assets', 'google', 'accounts.google.com']
      }
    }),
    provideTheme(),
    provideIconLoader((name) => {
      const http = inject(HttpClient);
      return http.get(`/assets/icons/${name}.svg`, { responseType: 'text' });
    }),
    provideOAuthClient({
      resourceServer: {
        allowedUrls: [environment.apiUrl],
        sendAccessToken: true
      }
    }),
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService
    }
  ]
};
